import {
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
} from "../../utils/types/organization";

export const BASE_URL = "/admin/organizations";

export type CreateOrUpdateOrganization = CreateOrganizationRequest &
  UpdateOrganizationRequest;

export const INITIAL_VALUES: CreateOrUpdateOrganization = {
  name: "",
  description: "",
  phone: "",
  email: "",
  domains: "",
  address: {
    street: "",
    number: "",
    zipcode: "",
    city: "",
    state: "",
  },
  deactivateUsersWithoutWhitelistEmail: true,
};

export const VALIDATIONS = {
  name: "required|organization-name",
  phone: "required|phone",
  email: "email",
  domains: "required|domain-name-list|reside-domain",
  address: {
    street: "required",
    zipcode: "required|zip-code",
    city: "required",
    state: "required",
  },
};

